import { api } from "../index";
import { PaginatedResponse, CollaborateFormData } from "../types";
import { toFrontStatus } from "../admin/status";

// Tipo básico para listagem de colaborações (ajuste conforme backend)
export interface UserCollaborationSummary {
  colaboracao_id: string;
  nome_especie: string;
  status: "pending" | "approved" | "rejected" | "correction" | string;
  created_at?: string;
}

export interface UserCollaborationDetail extends UserCollaborationSummary {
  pais?: string;
  estado?: string;
  municipio?: string;
  regiao?: string;
  latitude?: string;
  longitude?: string;
  altitude?: string;
  coletor?: string;
  instituicao_coletor?: string;
  autor_foto?: string;
  instituicao_autor?: string;
  SISBIO?: string;
  SISGEN?: string;
  observacoes?: string;
}

// Lista colaborações do usuário com paginação
export const listUserCollaborations = async (
  userId: number,
  token?: string | null,
  page: number = 1,
  pageSize: number = 20
): Promise<PaginatedResponse<UserCollaborationSummary>> => {
  const response = await api.get(`/colaboracoes/usuario/${userId}`, {
    params: { page, pageSize },
    headers: token ? { "X-CSRF-Token": token } : undefined,
  });
  const data = response.data as PaginatedResponse<UserCollaborationSummary>;
  return {
    ...data,
    items: data.items.map((c: any) => ({
      ...c,
      status: toFrontStatus(c.status),
    })),
  };
};

export const getUserCollaborationById = async (
  id: string | number,
  token?: string | null
): Promise<UserCollaborationDetail> => {
  const response = await api.get(`/colaboracoes/${id}`, {
    headers: token ? { "X-CSRF-Token": token } : undefined,
  });
  const c = response.data;
  return { ...c, status: toFrontStatus(c.status) };
};

export const createCollaboration = async (
  colaboracaoData: CollaborateFormData,
  token?: string | null,
  userId?: number | null
) => {
  try {
    // Campos opcionais vazios não devem ser enviados como valores inválidos.
    const dataToSend = {
      ...colaboracaoData,
      data: colaboracaoData.data,
      altitude: colaboracaoData.altitude?.trim() || undefined,
      SISBIO: colaboracaoData.SISBIO?.trim() || undefined,
      SISGEN: colaboracaoData.SISGEN?.trim() || undefined,
      instituicao_autor: colaboracaoData.instituicao_autor || "", // Garantir que não seja undefined
    };


    // O proprietário é obtido da sessão pelo backend, não de um ID na URL.
    const response = await api.post("/colaboracoes", dataToSend, {
      headers: {
        "X-CSRF-Token": token,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Erro na API de criação:", error);
    throw error;
  }
};

export const uploadImageToCollaboration = async (
  imageFormData: FormData,
  token: string,
  collaborationId?: string | null
) => {
  try {
    
    

    const response = await api.post(
      `/imagens/${collaborationId}/upload`,
      imageFormData,
      {
        headers: {
          "X-CSRF-Token": token,
          // NÃO definir Content-Type para FormData - deixar o browser definir
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error("Erro na API de upload:", error);
    if (error.response) {
      console.error("Status:", error.response.status);
      console.error("Data:", error.response.data);
      console.error("Headers:", error.response.headers);
    }
    throw error;
  }
};
export async function deleteCollaboration(id: string, token: string) {
  const res = await api.delete(`/colaboracoes/${id}`, {
    headers: { "X-CSRF-Token": token },
  });
  return res.data;
}

export async function updateUserCollaboration(
  id: string | number,
  data: Partial<UserCollaborationDetail>,
  token: string
) {
  const res = await api.put(`/colaboracoes/${id}`, data, {
    headers: { "X-CSRF-Token": token },
  });
  return res.data as UserCollaborationDetail;
}
